import { Popover } from 'antd';
import { IconProps } from 'react-feather';
import { Link } from 'react-router-dom';
import { ImDownload } from 'react-icons/im';

interface Props {
  redirect?: string;
  iconProps?: IconProps;
  content?: string;
  disabled?: boolean;
}

const DownloadIcon: React.FC<Props> = ({
  content = 'Baixar PDF',
  disabled = false,
  redirect,
  iconProps,
}) => {
  const icon = (
    <ImDownload
      {...iconProps}
      size={20}
      cursor={'pointer'}
      onClick={!disabled ? iconProps?.onClick : undefined}
      style={{
        cursor: disabled ? 'not-allowed' : undefined,
        color: disabled ? 'darkgray' : undefined,
        pointerEvents: disabled ? 'none' : undefined,
      }}
    />
  );

  return (
    <Popover content={content}>
      {redirect ? (
        <span
          style={{
            cursor: disabled ? 'not-allowed' : undefined,
          }}
        >
          <Link
            to={redirect}
            style={{
              pointerEvents: disabled ? 'none' : undefined,
            }}
          >
            {icon}
          </Link>
        </span>
      ) : (
        icon
      )}
    </Popover>
  );
};

export default DownloadIcon;
